export const services = [
  'device',
  'frontend',
  'inventory',
];
